import {
    Accordion,
    AccordionDetails,
    AccordionSummary, Alert, Autocomplete, Button,
    Checkbox,
    FormControlLabel,
    TextField, Tooltip
} from "@mui/material";
import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { CampaignTagSelect } from "../../../components/MaterialSelects/CampaignTagSelect";
import WaitSpinner from "../../../components/wait-spinner";
import { CampaignOutletContextValue } from "../form";
import { PaymentTermSelect } from "../../../components/MaterialSelects/PaymentTermSelect";
import { useDaybookContext } from "../../../contexts/Daybook/DayBookContext";

const PortfolioPane = () => {
    const { values, onChange, loading, errors, isDirty, readOnly, setTab } = useOutletContext<CampaignOutletContextValue>();
    const daybook = useDaybookContext();

    useEffect(() => {
        setTab('portfolio');
    }, []);

    if (loading) {
        return <WaitSpinner variant="panel" />;
    }

    const field = {
        onChange: onChange,
        loading: loading,
        readOnly: readOnly
    };
    const url = values?.externalPortfolioUrl;
    //var url = window.location.protocol + '//' + window.location.hostname + '/campaign-preview/' + values.job_reference + '/' + values.portfolio_hash
    let linkValue = null;
    if (values?.portfolio_hash === '') {
        linkValue = <Alert severity="info">Campaigns do not have a proposal link until after creation</Alert>;
    }
    if (values?.portfolio_hash !== '') {
        linkValue = <Button component="a" target="_blank" rel="noopener noreferrer" href={url}>Open proposal in new tab</Button>;
    }
    if (isDirty) {
        linkValue = <Alert severity="warning">Please save changes before opening portfolio</Alert>
    }

    console.log('values are', values);
    return (
        <div className="is-scrollable">
            <Accordion defaultExpanded={true}>
                <AccordionSummary>Campaign Proposal</AccordionSummary>
                <AccordionDetails>
                    <div className="grid12">

                        <TextField label="Client cover note" name="portfolio_summary" {...field} multiline={true} value={values.portfolio_summary} error={!!errors?.portfolio_summary} />
                        <TextField name="media_production_notes" {...field} multiline={true} label="Media production notes" value={values.media_production_notes} error={!!errors?.media_production_notes} />
                        <FormControlLabel label="Impact Figures" control={<Checkbox name="portfolio_show_impacts" {...field} disabled={readOnly} checked={!!values.portfolio_show_impacts} />} />
                        <Tooltip title="Include 4 sheets &amp; slot bookings in Panel Booking Section">
                            <FormControlLabel label="Small Sites" control={<Checkbox name="portfolio_small_sites" {...field} disabled={readOnly} checked={!!values.portfolio_small_sites} />} />
                        </Tooltip>
                        {daybook?.theme == 'nightbook' && <FormControlLabel label="Paris Insurance T&C" control={<Checkbox name="portfolio_paris_insurance" {...field} disabled={readOnly} checked={!!values.portfolio_paris_insurance}  />} />}
                        {linkValue}
                    </div>
                    <PaymentTermSelect name="paymentTerms" {...field} label="Payment Terms" value={values.paymentTerms}/>
                    <CampaignTagSelect multiple={true} fill={true} value={values.previewTags} name="previewTags" {...field} label="Options" />
                </AccordionDetails>
            </Accordion>
        </div>
    );
}


export default PortfolioPane;
